import { render, staticRenderFns } from "./PriceRangeFilter.vue?vue&type=template&id=cb24fa36"
import script from "./PriceRangeFilter.vue?vue&type=script&lang=js"
export * from "./PriceRangeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports